import { Col, Container, Row } from "react-bootstrap"

export const BaseContainer = ({ children,min_height }) => {
    return (
        <Container
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: min_height ? min_height : '65vh' }}>
            <Row className="w-100">
                <Col xs={12} sm={10} md={6} lg={4} className="mx-auto">
                    {children}
                </Col>
            </Row>
        </Container>
    )
}